import { FileExcelOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { ContentFilters } from 'components';
import { UploadListTopBar } from 'features/transaction_list/component/top-bar/upload-list-bar';
import { UploadList } from 'features/transaction_list/component/transaction-table-list/upload-list';
import {
  UploadFilterFormField,
  UploadFilterFormValuesPaginated,
} from 'features/transaction_list/component/upload-filter-form/types';
import { UploadFilterForm } from 'features/transaction_list/component/upload-filter-form/upload-filter-form';
import { GroupRegistrationModal } from 'features/transaction_list/modal/group-registration-modal';
import { useGetBulkUploadList } from 'features/transaction_list/use-cases/get-bulk-upload-list';
import { usePaginationParams } from 'hooks';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';

export const UploadListView = () => {
  const location = useLocation();
  const formId = 'upload-list-filter';

  const [grp, setGRP] = useState<boolean>(false);
  const [modalType, setModalType] = useState<string>("Gropu Registration");


  const getInitialFilterValues = {
    [UploadFilterFormField.GroupId]: undefined,
    [UploadFilterFormField.GroupName]: undefined,
    [UploadFilterFormField.Phone]: undefined,
    [UploadFilterFormField.Email]: undefined,
    [UploadFilterFormField.EventId]: undefined,
    [UploadFilterFormField.Flag]: "admin",
  };

  const updatedFlag: string | undefined = location.pathname.includes(
    '/group-registration-List',
  )
    ? 'GroupRegistration'
    : undefined;

  const updatedTitle: string | undefined = location.pathname.includes(
    '/group-registration-List',
  )
    ? 'Group Registration & Bulk Upload'
    : 'Bulk Upload List';

  const { params, updateParams, resetPage } = usePaginationParams<any>({
    // Flag: 'admin',
     Origin:"Null",  // 👈 Default to "Null" // updatedFlag
    page: 1,
    size: 10,
    ...getInitialFilterValues
  });
  
  
  const { data, refetch, isFetching } = useGetBulkUploadList(params);
  const handleFiltersChange = (values: UploadFilterFormValuesPaginated) => {
    updateParams(values);
    resetPage();
    refetch();
  };

  // useEffect(() => {
  //   updateParams({
  //     ...params,
  //     Origin: updatedFlag,
  //   });
  //   refetch();
  // }, [updatedFlag, refetch]); // Dependency on updatedFlag and refetch

  const openGRModal = (val: string) => {
    setGRP(true);
    setModalType(val);
    document.body.style.overflow = 'hidden';
  }

  const closeParticipantModal = () => {
    setGRP(false);
    setModalType("");
    document.body.style.overflow = 'visible';
  }

  return (
    <>

      {/* updatedFlag={updatedFlag} */}
      {/* )} */}

      <div className={`cstmrightmdl ${grp && "show"}`}>
        <GroupRegistrationModal
          closeModal={closeParticipantModal}
          isOpen={grp}
          modalType={modalType}
        />
      </div>

      <div className='grp_head'>
        <UploadListTopBar updatedTitle={updatedTitle} />
        <Button
          icon={<FileExcelOutlined />}
          onClick={() => openGRModal("GroupRegisrationReport")

          }
          type='primary'
        // loading={loading}
        >
          Group Registration Report
        </Button>

      </div>
      {/* <ContentTopBar
              title={''}
      
              renderButtons={
                <div className='parti_btn'>
                  <Tooltip title={"Export"}>
                   
                  </Tooltip>
      
             
                </div>
              }
            /> */}

      <ContentFilters formId={formId}>
        <UploadFilterForm
          formId={formId}
          handleFilter={handleFiltersChange}
          initialValues={getInitialFilterValues as any}
        />
      </ContentFilters>

      <UploadList
        isSocialListLoading={isFetching}
        DeliveryList={data}
        tableParams={params as any}
        updateParams={updateParams}
        refetch={refetch}
        updatedFlag={updatedFlag}
      />
    </>
  );
};
